import { useMemo } from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  LegendType,
} from "api/interfaces/dashboardInterface.interface";
import { formatPercent, getRowsAndItems } from "utils/StatsUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useQuery } from "react-query";
import { getActiveAlert } from "api/widgetAPI";

export default function ActiveAlert(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const activeAlert = useQuery(
    ["activeAlert", selectedAccount.accountId],
    () => getActiveAlert({ accountId: selectedAccount.accountId }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const { rows, items } = useMemo(() => {
    if (activeAlert.data) {
      return getRowsAndItems(
        [
          { label: "System", value: activeAlert.data.result?.systemCount ?? 0 },
          { label: "Video", value: activeAlert.data.result?.videoCount ?? 0 },
          { label: "Disk", value: activeAlert.data.result?.diskCount ?? 0 },
        ],
        props.items
      );
    }
    return getRowsAndItems([], props.items);
  }, [props.items, activeAlert.data]);
  const legend: LegendType[] = useMemo(() => {
    let legend: LegendType[] = [...rows] as unknown as LegendType[];
    const total = legend.reduce((acc, curr) => acc + Number(curr.value), 0);
    return items.map((item, index) => ({
      label: item.label,
      value: formatPercent(Number(rows[index].value ?? 0), total),
      color: item.color,
    }));
  }, [items, rows]);
  return (
    <ChartWrapper rows={rows} items={items} unit="percent" legend={legend} />
  );
}
